module.exports = __webpack_public_path__ + "img/KarlusMorales_Imagotype_Dark_120_Shadow.83458288.svg";